import { useDispatch, useSelector } from "react-redux";
import "./edit-profile.css";
import { useState } from "react";
import { BASE_URL } from "../assets/constant";
import axios from "axios";
import { CustomModal } from "../components/custom-modal";
import { loggedIn } from "../redux/authSlice";
export const EditProfile = () => {
  const info = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [data, setData] = useState({
    fname: info.user.fname,
    lname: info.user.lname,
    phone: info.user.phone
  });
  const [showModal, setShowModal] = useState(false);

  const handleValueChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value
    }));
    console.log(name, value);
  };

  const handleRedirect = () => {
    window.history.back();
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const { fname, lname, phone } = data;
      await axios.post(
        `${BASE_URL}/users/update-profile`,
        {
          email: info.user.email,
          fname,
          lname,
          phone
        },
        {
          headers: {
            Authorization: `Bearer ${info.token}`
          }
        }
      );
      setShowModal(true);
      dispatch(
        loggedIn({
          user: {
            ...info.user,
            fname,
            lname,
            phone
          }
        })
      );
    } catch (error) {}
  };

  const isButtonDisabled = () =>
    data.fname.trim() === "" ||
    data.lname.trim() === "" ||
    data.phone.trim() === "" ||
    (data.fname.trim() === info.user.fname &&
      data.lname.trim() === info.user.lname &&
      data.phone.trim() === info.user.phone);

  return (
    <div className="subscriber-container">
      <div className="edit-profile-container">
        <header>
          <div style={{ display: "flex" }}>
            <i
              className="fa-solid fa-arrow-left"
              style={{
                paddingRight: "10px",
                fontSize: "14px",
                cursor: "pointer"
              }}
              onClick={handleRedirect}></i>
            <h4>Edit Profile</h4>
          </div>
        </header>
        {showModal && (
          <CustomModal
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            heading="Profile Updated"
            text={`Profile updated successfully`}
            btnName={"Close"}
            onClick={() => setShowModal(false)}
          />
        )}
        <div className="edit-profile-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="fname">First Name</label>
              <input
                type="text"
                className="form-control"
                id="fname"
                name="fname"
                placeholder="Enter First Name"
                onChange={handleValueChange}
                value={data.fname}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lname">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="lname"
                placeholder="Enter Last Name"
                onChange={handleValueChange}
                name="lname"
                value={data.lname}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter Email"
                disabled={true}
                value={info.user.email}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="text"
                className="form-control"
                id="phone"
                placeholder="Enter Phone"
                pattern="[0-9]{10}"
                name="phone"
                value={data.phone}
                onChange={handleValueChange}
                required
                title="Enter 10 digit mobile number"
              />
            </div>
            <button
              type="submit"
              className={`${
                !isButtonDisabled() ? "recallButton" : "disabledButton"
              }`}
              disabled={isButtonDisabled()}
              style={{
                borderRadius: "5px"
              }}>
              Update
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
